export * from './lib/ui-fund-chips';
export * from './lib/ui-fund-chips.model';
